<template>
  <div class="shopeepay-content">
    <div class="shopeepay-desc">
      กรุณาใช้แอป <strong>ShopeePay</strong> สแกน QR Code
      เพื่อชำระเงิน
    </div>

    <div
      :class="[
        'shopeepay-qr-code-container',
        { expired: isExpired || !qrCode },
      ]"
    >
      <v-icon
        v-if="isExpired || !qrCode"
        color="#eba714"
        size="48"
        class="expired-icon"
      >
        mdi-alert-circle-outline
      </v-icon>

      <qrcode-vue v-else :value="qrCode" size="150" />
    </div>

    <div class="text-center">
      <div v-if="orderCode" class="shopeepay-order-code">
        รายการสั่งซื้อ <strong> #{{ orderCode }} </strong>
      </div>

      <div class="shopeepay-amount">฿{{ total }}</div>
    </div>
    <span v-if="storeName" class="shopeepay-owner">
      {{ storeName }}
    </span>

    <div class="shopeepay-countdown-container">
      <span v-if="!isExpired">
        กรุณาดำเนินการชำระเงินภายใน
      </span>
      <div class="shopeepay-count-badge">
        {{ isExpired ? 'หมดเวลาทำรายการ' : timer }}
      </div>
      <div v-if="isExpired" class="mt-2">
        กรุณากดปุ่ม "สั่งซื้ออีกครั้ง" เพื่อทำรายการใหม่
      </div>
      <div v-else>
        {{ expiryDateTime }}
      </div>
    </div>

    <div v-if="!isExpired" class="shopeepay-hint-container">
      <span class="shopeepay-hint">
        <v-icon size="14" color="red">
          mdi-information-outline
        </v-icon>
        กรุณาอย่าออกจากหน้าหรือรีเฟรชหน้าจอ ขณะทำการชำระเงิน
      </span>
    </div>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'

export default {
  name: 'ShopeePayContent',
  components: {
    QrcodeVue,
  },
  props: {
    isExpired: {
      type: Boolean,
      default: false,
    },
    qrCode: {
      type: String,
      default: '',
    },
    orderCode: {
      type: String,
      default: '',
    },
    total: {
      type: String,
      required: true,
    },
    storeName: {
      type: String,
      required: true,
    },
    timer: {
      type: String,
      default: '',
    },
    expiryDateTime: {
      type: String,
      default: 'dd/mm/yyyy HH:mm',
    },
  },
}
</script>

<style lang="scss" scoped>
.shopeepay-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.shopeepay-qr-code-container {
  width: 100%;
  max-width: 150px;
  aspect-ratio: 1 / 1;
  display: flex;

  &.expired {
    border-radius: 8px;
    background-color: #eba71426;
  }

  .expired-icon {
    margin: auto;
  }
}

.shopeepay-amount {
  font-size: 20px;
  font-weight: bold;
}
.shopeepay-order-code,
.shopeepay-owner {
  font-size: clamp(14px, 1vw, 16px);
}

.shopeepay-owner {
  color: #707070;
}

.shopeepay-desc,
.shopeepay-countdown-container {
  text-align: center;
  font-size: clamp(14px, 1.25vw, 16px);
}

.shopeepay-countdown-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  font-weight: bold;

  .shopeepay-count-badge {
    width: fit-content;
    background-color: #ee4d2d;
    color: #fff;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: clamp(16px, 1vw, 18px);
    font-weight: bold;
  }
}

.shopeepay-hint-container {
  width: 100%;
  padding: 4px 8px;

  background-color: #fff3f3;
  border-radius: 4px;

  overflow: hidden;
  text-align: center;

  .shopeepay-hint {
    font-size: clamp(12px, 1vw, 14px);
    font-weight: bold;
    color: red;
    animation: fade-in-out 1s ease-in-out infinite;
  }
}

@keyframes fade-in-out {
  0% {
    opacity: 0.25;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.25;
  }
}
</style>
